import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthStore } from "@/stores/auth";
import {
  supplierCanAccessPath,
  workspaceHomePath,
} from "@/lib/workspaceAccess";

export function SupplierRouteGuard({ children }: { children: ReactNode }) {
  const role = useAuthStore((state) => state.user?.role);
  const { pathname } = useLocation();
  return supplierCanAccessPath(role, pathname) ? (
    <>{children}</>
  ) : (
    <Navigate to={workspaceHomePath(role)} replace />
  );
}
